export type OverlayMenuType =
  | "none"
  | "account"
  | "support"
  | "cart"
  | "deals"
  | "vendorOrderItems"
  | "moneyBackGuarantee"
  | "houseBrand"
  | "sellerOptions"
  | "exportPackage"
  | "deliveryAddress";

/** Menus opened only via dedicated actions (not `setOpenMenu` string). */
export type SetOpenMenuPayload = Exclude<OverlayMenuType, "vendorOrderItems">;

/** How the drawer is positioned relative to the sticky header (see `DrawerMenu` `layoutVariant`). */
export type OverlayDrawerLayoutVariant = "belowHeader" | "overHeader";

/**
 * Menu keys that use the over-header drawer: full-height side panel on desktop, body-portaled above
 * Bootstrap modals. Add new keys here when introducing another over-header overlay.
 */
export const OVER_HEADER_MENU_KEYS: ReadonlySet<Exclude<OverlayMenuType, "none">> = new Set<
  Exclude<OverlayMenuType, "none">
>(["vendorOrderItems", "moneyBackGuarantee", "houseBrand", "sellerOptions", "exportPackage", "deliveryAddress"]);

/** Over-header drawers with a line under the header instead of a shadow. */
export const HEADER_LINE_MENU_KEYS: ReadonlySet<OverlayMenuType> = new Set<OverlayMenuType>([
  "houseBrand",
  "exportPackage",
]);

export function getOverlayDrawerLayoutVariant(menuKey: OverlayMenuType): OverlayDrawerLayoutVariant {
  if (menuKey === "none") {
    return "belowHeader";
  }
  return OVER_HEADER_MENU_KEYS.has(menuKey) ? "overHeader" : "belowHeader";
}
